module.exports = "/images/procedures-placeholder.ce49ef7ec2d32aad9cfc49be4cd580a2.svg";